import React, { Component } from "react";
import Datacenters from "./Datacenters";
import Jumbotron from "./Jumbotron";
import NavBar from "./NavBar";
import { ONLINE, UNAVAILABLE } from "./StatusOptions";
import strings from "./strings";

const initState = [
  {
    name: "IIT/IK Cloud",
    url: "https://ik.cloud.bme.hu",
    status: ONLINE,
  },
  {
    name: "VIK Cloud",
    url: "https://smallville.cloud.bme.hu",
    status: ONLINE,
  },
  {
    name: "KIFÜ-NIIF Cloud",
    url: "https://niif.cloud.bme.hu",
    status: ONLINE,
  },
  {
    name: "Füred Cloud",
    url: "https://fured.cloud.bme.hu",
    status: ONLINE,
  },
];

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("timeout"));
    }, ms);
    promise.then(resolve, reject);
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = { datacenters: this.initLocalization(initState) };
  }

  refreshStatus() {
    this.state.datacenters.forEach((dc, idx) => {
      timeout(
        2000,
        fetch(dc.url).then((_) => {
          const updatedDataCenter = {
            ...dc,
            status: ONLINE,
            statusText: strings.online,
          };
          this.setState({
            datacenters: Object.assign([], this.state.datacenters, {
              [idx]: updatedDataCenter,
            }),
          });
        })
      ).catch(() => {
        const updatedDataCenter = {
          ...dc,
          status: UNAVAILABLE,
          statusText: strings.unavailable,
        };
        this.setState({
          datacenters: Object.assign([], this.state.datacenters, {
            [idx]: updatedDataCenter,
          }),
        });
      });
    });
  }

  componentDidMount() {
    this.refreshStatus();
    setInterval(() => this.refreshStatus(), 5000);
  }

  changeLocalization = (newLoc) => {
    strings.setLanguage(newLoc);
    const newState = this.makeLocalization(this.state.datacenters);
    this.setState({ datacenters: newState });
  };

  makeLocalization = (defState) => {
    let newState = [...defState];
    return newState.map((dc) => {
      return { ...dc, statusText: strings[dc.status] };
    });
  };

  initLocalization = (defState) => {
    let newState = [...defState];
    return newState.map((dc) => {
      return { ...dc, statusText: strings.loading };
    });
  };

  render() {
    return (
      <div className="page">
        <NavBar handleLocChange={(loc) => this.changeLocalization(loc)} />
        <Jumbotron strings={strings} />
        <Datacenters datacenters={this.state.datacenters} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js